/**
 * InstallPromptBanner — Landlord
 * Non-blocking banner shown on mobile when the app is installable
 * and the 30-day cooldown has not been triggered.
 */

import { useInstallPrompt } from '../contexts/InstallPromptContext';

export function InstallPromptBanner() {
  const { shouldShowBanner, promptInstall, dismissBanner } = useInstallPrompt();
  if (!shouldShowBanner) return null;

  return (
    <div
      role="banner"
      data-testid="install-prompt-banner"
      className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-between gap-3 px-4 py-3 bg-card border-t border-border shadow-lg"
    >
      <p className="text-sm text-foreground m-0">
        Install Resida on your home screen for faster access.
      </p>
      <div className="flex gap-2 flex-shrink-0">
        <button
          data-testid="install-prompt-install-btn"
          onClick={promptInstall}
          className="px-3 py-1.5 text-sm font-medium bg-primary text-primary-foreground rounded-md hover:opacity-90"
        >
          Install
        </button>
        <button
          data-testid="install-prompt-dismiss-btn"
          onClick={dismissBanner}
          className="px-3 py-1.5 text-sm font-medium text-muted-foreground hover:text-foreground"
        >
          Not now
        </button>
      </div>
    </div>
  );
}
